export type ThemePreference = "system" | "light" | "dark";

const KEY = "wv-theme";

export function storedTheme(): ThemePreference {
  try {
    const value = localStorage.getItem(KEY);
    return value === "light" || value === "dark" ? value : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(preference: ThemePreference): void {
  const root = document.documentElement;
  if (preference === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", preference);
  try {
    if (preference === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, preference);
  } catch {
    // Storage unavailable (private mode): the choice lasts for this page.
  }
}

export function applyStoredTheme(): void {
  applyTheme(storedTheme());
}
